var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    viewBox: "0 0 268 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Marker-B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 134.279776,
    cy: 134.279776,
    r: 98.83015
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marker-B",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(-0.279776, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3296358,39.3296358 C91.7691501,-13.1098786 176.790402,-13.1098786 229.229916,39.3296358 C281.66943,91.7691501 281.66943,176.790402 229.229916,229.229916 L144.829791,313.63004 C139.003179,319.456653 129.556373,319.456653 123.72976,313.63004 L39.3296358,229.229916 C-13.1098786,176.790402 -13.1098786,91.7691501 39.3296358,39.3296358 Z",
    id: "Marker",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Kreis",
    fill: "#EAF4DC",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "B",
    transform: "translate(95.753200, 81.815000)",
    fill: "#85CF39",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.11,49.8888 C78.3756,45.756 83.2464,37.638 83.2464,27.306 C83.2464,10.1844 70.4052,0 49.2984,0 L0,0 L0,103.32 L49.2984,103.32 C73.062,103.32 86.4936,92.988 86.4936,74.6856 C86.4936,63.6156 79.4088,53.2836 70.11,49.8888 Z M49.8888,15.3504 C60.0732,15.3504 66.2724,20.5164 66.2724,29.0772 C66.2724,37.638 60.2208,42.6564 49.8888,42.6564 L17.1216,42.6564 L17.1216,15.3504 L49.8888,15.3504 Z M51.2172,87.6744 L17.1216,87.6744 L17.1216,57.564 L51.3648,57.564 C62.5824,57.564 69.372,63.1728 69.372,72.4716 C69.372,81.918 62.4348,87.6744 51.2172,87.6744 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinB);
export default __webpack_public_path__ + "static/media/pin-b.642cd97fcb76deae404018186286264e.svg";
export { ForwardRef as ReactComponent };